import React from "react";
import p1 from "../../assets/images/nexus/1.png";
import p2 from "../../assets/images/nexus/2.png";
import p3 from "../../assets/images/nexus/3.png";
import p5 from "../../assets/images/nexus/5.png";
import p6 from "../../assets/images/nexus/6.png";
import p7 from "../../assets/images/nexus/7.png";
import p8 from "../../assets/images/nexus/8.png";
import p9 from "../../assets/images/nexus/9.png";
import p10 from "../../assets/images/nexus/10.png";
import p11 from "../../assets/images/nexus/11.png";
import p12 from "../../assets/images/nexus/12.png";
import p13 from "../../assets/images/nexus/13.png";
import p14 from "../../assets/images/nexus/14.png";
import p15 from "../../assets/images/nexus/15.png";
import p16 from "../../assets/images/nexus/16.png";
import p17 from "../../assets/images/nexus/17.png";
import p19 from "../../assets/images/nexus/19.png";
import p20 from "../../assets/images/nexus/20.png";
import p21 from "../../assets/images/nexus/21.png";
import p22 from "../../assets/images/nexus/22.png";
import p24 from "../../assets/images/nexus/24.png";
import p25 from "../../assets/images/nexus/25.png";
import p29 from "../../assets/images/nexus/29.png";
import p48 from "../../assets/images/nexus/49.png";
import ProjectCard from "../reusables/ProjectCard";
import Cta from "../reusables/Cta";

const PortfolioBody = () => {
  return (
    <section className="section-spacing-80">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-content">
              <div className="section-body section-spacing-20">
                <ul className="projects-container">
                  <ProjectCard
                    img={p1}
                    caption="Valentine's Toast to Love Dinner at Kampala Serena Hotel"
                  />
                  <ProjectCard
                    img={p2}
                    caption="Ladies Affair at Nexus Lounge"
                  />
                  <ProjectCard img={p3} caption="DJAU Awards at Nexus Lounge" />
                  <ProjectCard
                    img={p5}
                    caption="Beta Fashion Weekend at The Square"
                  />
                  <ProjectCard
                    img={p6}
                    caption="Becky's Apparel Fashion Launch at Wild Coffee Bar"
                  />
                  <ProjectCard
                    img={p7}
                    caption="Annual Makerere Engineering Society Dinner at Sheraton Hotel"
                  />
                  <ProjectCard
                    img={p8}
                    caption="VIGA Music Awards at Serena Hotel"
                  />
                  <ProjectCard
                    img={p9}
                    caption="VIGA Music Awards at Serena Hotel"
                  />
                  <ProjectCard
                    img={p10}
                    caption="VIGA Music Awards at Serena Hotel"
                  />
                  <ProjectCard
                    img={p11}
                    caption="Ultra-Music experience at Nexus Lounge"
                  />
                  <ProjectCard
                    img={p12}
                    caption="Ultra-Music experience at Nexus Lounge"
                  />
                  <ProjectCard
                    img={p13}
                    caption="Ultra-Music experience at Nexus Lounge"
                  />
                  <ProjectCard
                    img={p14}
                    caption="Ultra-Music experience at Nexus Lounge"
                  />
                  <ProjectCard
                    img={p15}
                    caption="Pastor Enoch Adeboye RCCG Crusade at Kololo Airstrip"
                  />
                  <ProjectCard
                    img={p16}
                    caption="Pastor Enoch Adeboye RCCG Crusade at Kololo Airstrip"
                  />
                  <ProjectCard
                    img={p17}
                    caption="Feast of Esther Breakfast Meeting at Imperial Royal Hotel"
                  />
                  <ProjectCard img={p19} caption="Introduction at Munyoyo" />
                  <ProjectCard img={p20} caption="Introduction at Munyoyo" />
                  <ProjectCard
                    img={p21}
                    caption="Mufti Ismail Menk VVIP Dinner at Pearl of Africa Hotel"
                  />
                  <ProjectCard
                    img={p22}
                    caption="Mufti Ismail Menk VVIP Dinner at Pearl of Africa Hotel"
                  />
                  <ProjectCard
                    img={p24}
                    caption="Monthly Star Saturday Setups at Nexus Lounge"
                  />
                  <ProjectCard
                    img={p25}
                    caption="Monthly Star Saturday Setups at Nexus Lounge"
                  />
                  <ProjectCard
                    img={p29}
                    caption="Alikiba Live at Lugogo Hockey Grounds"
                  />
                  <ProjectCard img={p48} caption="Cindy's Boom Party Concert" />
                </ul>
              </div>
              <div className="section-footer buttons-container flex justify-center section-spacing-20 no-padding-bottom">
                <Cta />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PortfolioBody;
